.saveProfileContinaer {
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 0.625rem;
}

.warningWrapper {
	display: flex;
	flex-direction: row;
	background: linear-gradient(180deg, #fbf8ff 0%, #f4f1ff 100%);
	width: 100%;
	border: 2px solid #ebddff;
	padding: 0.625rem;
	box-sizing: border-box;
	box-shadow: 0px 1px 2px -1px #0000001a;
	border-radius: 12px;
	align-items: center;
	gap: 0.5rem;

	.warningIconContainer {
		width: 36px;
		height: 36px;
		border-radius: 8px;
		padding: 0.5rem;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #fff;
		box-sizing: border-box;
		box-shadow: 0px 1px 2px -1px #0000001a;
		box-shadow: 0px 1px 3px 0px #0000001a;

		& svg {
			color: #42296e;
			flex-shrink: 0;
		}
	}

	& :global(.MuiTypography-root) {
		color: #525252;
		font-weight: 400;
		font-size: 0.9375rem;
		line-height: 1.5;
		letter-spacing: -0.15px;
	}
}

.section {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	width: 100%;

	& .title {
		color: #000000;
		font-weight: 600;
		font-size: 1rem;
		line-height: 1.4;
		letter-spacing: 0;
		border-bottom: 1px solid #e0e0e0;
		width: 100%;
	}

	& .description {
		color: #000000;
		font-weight: 400;
		line-height: 1.5;
		font-size: 0.9375rem;
	}
}

.profileRadioGroup {
	gap: 1rem;

	& :global(.MuiFormControlLabel-root) {
		gap: 0.5rem;
		margin: 0;
	}
}

.profileRadioRow {
	display: flex;
	flex-direction: row;
	gap: 0.5rem;
	align-items: center;

	& .iconWrapper {
		border-radius: 10.67px;
		width: 32px;
		height: 32px;
		flex-shrink: 0;
		padding: 0.5rem;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	& .description {
		color: #000000;
		font-weight: 400;
		font-size: 0.875rem;
		line-height: 1.6;
	}
}

.profileNameLabel:global(.MuiFormControlLabel-root) {
	width: 100%;
	justify-content: flex-end;
	margin-right: auto;
	margin-left: 0;
	gap: 1rem;

	& :global(.MuiFormControlLabel-label) {
		font-size: 0.9375rem;
		font-weight: 600;
		line-height: 1.5;
		color: #000000;

		min-width: fit-content;
	}

	.profileNameTextfield {
		width: 100%;
		height: 35px;

		& :global(.MuiOutlinedInput-root) {
			height: 100%;
		}
	}
}

@media (max-width: 768px) {
	.warningWrapper {
		flex-direction: column;
	}

	.profileNameLabel:global(.MuiFormControlLabel-root) {
		max-width: unset;
		width: 100%;
		flex-direction: column-reverse;
		gap: 0.5rem;
	}
}

.subAccountSelector {
	display: flex;
	flex-direction: column;
	gap: 8px;
	width: 100%;
}

.subAccountList {
	display: flex;
	flex-direction: column;
	max-height: 180px;
	overflow-y: auto;
	border: 1px solid #ececec;
	border-radius: 8px;
	padding: 8px;
	box-sizing: border-box;
}

.subAccountRow {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	min-width: 0;
}

.subAccountName {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	color: #262626;
	font-size: 14px;
	line-height: 1.5;
}

.subAccountEmpty:global(.MuiTypography-root) {
	color: #525252;
	font-size: 14px;
	line-height: 1.5;
}
